module.exports = __webpack_public_path__ + "static/media/crown.93952fc4.svg";